import React from "react";

import type { GroceryItem } from "@/client/api";
import { fmtRep } from "@/client/computations/grocery";

/**
 * A single grocery item row with checkbox, name, quantity (cyclable), and recipe hint.
 */
export function GroceryItemRow({
  item,
  repIndex,
  isChecked,
  onToggle,
  onCycleRep,
}: {
  item: GroceryItem;
  repIndex: number;
  isChecked: boolean;
  onToggle: () => void;
  onCycleRep?: () => void;
}) {
  const rep =
    item.representations.length > 0
      ? item.representations[repIndex % (item.representations.length || 1)]
      : null;
  const qtyStr = rep ? fmtRep(rep) : null;
  const canCycle = item.representations.length > 1;

  return (
    <label
      className={`flex items-start gap-2 pl-2 py-[3px] text-sm cursor-pointer ${isChecked ? "opacity-40" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        onToggle();
      }}
    >
      <input
        type="checkbox"
        checked={isChecked}
        readOnly
        className="accent-term-accent size-4 shrink-0 pointer-events-none"
      />
      <span className="leading-tight">
        <span className={`text-term-text ${isChecked ? "line-through" : ""}`}>{item.name}</span>
        {qtyStr ? (
          <>
            {" "}
            <span
              className={`text-sm text-term-accent font-medium whitespace-nowrap ${isChecked ? "line-through" : ""} ${canCycle ? "cursor-pointer hover:underline" : ""}`}
              onClick={
                canCycle
                  ? (e: React.MouseEvent) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onCycleRep?.();
                    }
                  : undefined
              }
              title={canCycle ? "Click para alternar unidad" : undefined}
            >
              {qtyStr}
            </span>
          </>
        ) : null}
        {item.descriptive.length > 0 && (
          <>
            {" "}
            <span
              className={`text-sm text-term-text-muted italic whitespace-nowrap ${isChecked ? "line-through" : ""}`}
            >
              {qtyStr ? "+ " : ""}
              {item.descriptive.join(" + ")}
            </span>
          </>
        )}
      </span>
      {item.recipes.length > 0 && (
        <span
          className="text-micro text-term-text-muted ml-auto shrink-0 mt-0.5"
          title={item.recipes.join(", ")}
        >
          {item.recipes.length > 1 ? `${item.recipes.length} recetas` : item.recipes[0]}
        </span>
      )}
    </label>
  );
}
